import r from "./isFunction.js";
import t from "./_toPath.js";
function o(o, l, a) {
  var i = (l = t(l)).length;
  if (!i) return r(a) ? a.call(o) : a;
  for (var n = 0; n < i; n++) {
    var u = null == o ? void 0 : o[l[n]];
    void 0 === u && (u = a, n = i), o = r(u) ? u.call(o) : u;
  }
  return o;
}
export { o as default };